var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"gft-overlay",attrs:{"catchtouchmove":""},on:{"click":_vm.hide}}):_vm._e(),_c('div',{staticClass:"inner",attrs:{"catchtouchmove":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }